import { cx } from '@linaria/core';
import { useQuery } from '@tanstack/react-query';
import { useMemo } from 'react';
import { TransitionGroup } from 'react-transition-group';
import { HeartIcon } from '@ui/kit/icons';
import { CSSRefTransition, SizeTransition } from '@utils/react';
import { heading, header } from '../../shared.header.style.js';
import { getBookshelfFavouritesQuery } from '../api/get-bookshelf-favourites.query.js';
import { getFavouritesQuery } from '../api/get-favourites.query.js';
import { BookCard } from '../molecule.book-card/_book-card.js';
import { FavouriteCard } from '../molecule.favourite-card/_favourite-card.js';
import { getInternalKeyForFavouriteDescriptor } from '../util.get-internal-key.js';
import { headingHeart, heading as heading$1, header as header$1, content, pageFadeDurationMs, message, listWrapper, listHeading, list, listItem, cardExitDurationMs, emptyListMessage } from './_favourites-page.style.js';
import { jsxs, jsx } from 'react/jsx-runtime';

function FavouritesPage() {
  const favourites = useQuery(getFavouritesQuery.useQueryConfig());
  const ibookFavourites = useQuery(getBookshelfFavouritesQuery.useQueryConfig());
  const sortedFavourites = useMemo(() => favourites.data?.sort((a, b) => (b.createdAt?.getTime() ?? 0) - (a.createdAt?.getTime() ?? 0)), [favourites.data]);
  const isPending = favourites.isPending || ibookFavourites.isPending;
  const withHeadings = !!ibookFavourites.data?.length && !!favourites.data?.length;
  return /*#__PURE__*/jsxs("section", {
    children: [/*#__PURE__*/jsx("header", {
      className: cx(header, header$1),
      children: /*#__PURE__*/jsxs("h1", {
        className: cx(heading, heading$1),
        children: ["Mine favoritter", !favourites.data?.length && /*#__PURE__*/jsx("span", {
          className: headingHeart,
          role: "presentation",
          children: /*#__PURE__*/jsx(HeartIcon, {
            height: 20
          })
        })]
      })
    }), /*#__PURE__*/jsx(TransitionGroup, {
      children: isPending ? /*#__PURE__*/jsx(CSSRefTransition, {
        timeout: pageFadeDurationMs,
        classNames: content,
        children: ref => /*#__PURE__*/jsx("div", {
          ref: ref,
          className: cx(content, message),
          children: "Indl\xE6ser..."
        })
      }) : /*#__PURE__*/jsx(CSSRefTransition, {
        timeout: pageFadeDurationMs,
        classNames: content,
        children: ref => /*#__PURE__*/jsxs("div", {
          ref: ref,
          className: content,
          children: [sortedFavourites?.length ? /*#__PURE__*/jsxs("section", {
            className: listWrapper,
            children: [withHeadings && /*#__PURE__*/jsx("h2", {
              className: listHeading,
              children: "Forl\xF8b"
            }), /*#__PURE__*/jsx("ul", {
              className: list,
              children: /*#__PURE__*/jsx(TransitionGroup, {
                component: null,
                children: sortedFavourites.map(it => /*#__PURE__*/jsx(SizeTransition, {
                  axis: "horisontal",
                  timeout: cardExitDurationMs,
                  classNames: listItem,
                  children: ref => /*#__PURE__*/jsx("li", {
                    ref: ref,
                    className: listItem,
                    children: /*#__PURE__*/jsx("div", {
                      children: /*#__PURE__*/jsx(FavouriteCard, {
                        context: "userarea-page",
                        descriptor: it
                      })
                    })
                  })
                }, getInternalKeyForFavouriteDescriptor(it)))
              })
            })]
          }) : favourites.isError ? /*#__PURE__*/jsx("div", {
            className: cx(message, emptyListMessage),
            children: "Noget gik galt da vi fors\xF8gte at indl\xE6se dine favoritter"
          }) : /*#__PURE__*/jsxs("div", {
            className: cx(message, emptyListMessage),
            children: ["Klik p\xE5 favorit-hjertet for at gemme forl\xF8b, s\xE5 du let kan finde dem igen.", /*#__PURE__*/jsx("br", {}), "Dine seneste favoritter vises ogs\xE5 p\xE5 forsiden."]
          }), !!ibookFavourites.data?.length && /*#__PURE__*/jsxs("section", {
            className: listWrapper,
            children: [/*#__PURE__*/jsx("h2", {
              className: listHeading,
              children: "B\xF8ger"
            }), /*#__PURE__*/jsx("ul", {
              className: list,
              children: /*#__PURE__*/jsx(TransitionGroup, {
                component: null,
                children: ibookFavourites.data.map(it => /*#__PURE__*/jsx(SizeTransition, {
                  axis: "horisontal",
                  timeout: cardExitDurationMs,
                  classNames: listItem,
                  children: ref => /*#__PURE__*/jsx("li", {
                    ref: ref,
                    className: listItem,
                    children: /*#__PURE__*/jsx("div", {
                      children: /*#__PURE__*/jsx(BookCard, {
                        book: it
                      })
                    })
                  })
                }, it.id))
              })
            })]
          })]
        })
      })
    })]
  });
}

export { FavouritesPage };
//# sourceMappingURL=_favourites-page.js.map
